<template>
  <b-badge :variant="resolveColor"> {{ resolveLabel }} </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  props: {
    value: String | Number,
  },
  computed: {
    resolveLabel() {
      return this.value === "new"
        ? "جديدة"
        : this.value === "in_progress"
        ? " قيد التدقيق "
        : this.value === "need_review"
        ? "بحاجة استدراك"
        : this.value === "corrected"
        ? "مُستدركة"
        : this.value === "open"
        ? "قيد المعالجة"
        : this.value === "rejected"
        ? "مرفوضة"
        : this.value === "waiting"
        ? "قيد الإنتظار"
        :  this.value === "accepted"
        ? " مقبولة"
        :  this.value === "need_correction"
        ? " بحاجة استدراك"
        : "جديدة" ;
    },
    resolveColor() {
      return this.value === "new"
        ? "light-success"
        : this.value === "in_progress"
        ? "light-info"
        : this.value === "need_review"
        ? "light-danger"
        : this.value === "corrected"
        ? "light-success"
        : this.value === "open"
        ? "light-primary"
        : this.value === "rejected"
        ? "light-danger"
        : this.value === "waiting"
        ? "light-secondary"
        : this.value === "accepted"
        ? "light-success"
        : this.value === "need_correction"
        ? "light-danger"
        : "light-secondary"
    },
  },
};
</script>
